export const getUserFilter = state => state.userAdmin.filter
